import { Routine } from 'redux-saga-routines';
import { getReportRoutine, searchReportUsersRoutine, setReportCandidatesRoutine } from './routines';
import { ISearchUser } from '../../common/models/user/ISearchUser';

export type ReportState = {
  users: ISearchUser[];
  loading: boolean;
  isCreatingReport: boolean;
  candidateIds: undefined | string[];
}

const initialState: ReportState = {
  users: [],
  loading: true,
  isCreatingReport: false,
  candidateIds: undefined
};

export const report = (state: ReportState = initialState, action: Routine<any>): ReportState => {
  switch (action.type) {
    case getReportRoutine.TRIGGER:
      return {
        ...state,
        isCreatingReport: true
      };
    case getReportRoutine.SUCCESS:
    case getReportRoutine.FAILURE:
      return {
        ...state,
        isCreatingReport: false
      };
    case searchReportUsersRoutine.TRIGGER:
      return {
        ...state,
        loading: true
      };
    case searchReportUsersRoutine.SUCCESS:
      return {
        ...state,
        users: action.payload,
        loading: false
      };
    case searchReportUsersRoutine.FAILURE:
      return {
        ...state,
        loading: false
      };
    case setReportCandidatesRoutine.TRIGGER:
      return {
        ...state,
        candidateIds: action.payload
      };
    default:
      return state;
  }
};
